import { v4 as uuidv4 } from 'uuid';
import { messageComponent } from '../../../../components/message/message.component';
import paginationComponent from '../../../../components/pagination/pagination.component';
import { staticUrls } from '../../../../config/constants';
import taskTodoModel from '../../../../models/task-management/to-do-management.model';
import ViewBase from '../../../view-base.view';

export default function ToDoSiteDetailsView() {
    ViewBase.call(this);

    let inputDataModel = {
        filter: "",
        taskName: "",
        isMandatory: "",
        radioOptional: "",
        radioComplete: "",
        data: [],
        fromDate: "",
        toDate: "",
        taskList: "",
        siteList: "",
        pageIndex: 1,
        pageSize: 10,
        totalCount: 0
    };

    let onClose = () => { };
    let parentInputParams;
    let filterparentParams;
    let type = "";
    let isMsgOpen = false;
    let showMsg = "";
    let msgTitle = "";

    let _getSiteDetailList = () => {
        this.showLoading();

        inputDataModel.fromDate = filterparentParams.fromDate;
        inputDataModel.toDate = filterparentParams.toDate;
        inputDataModel.taskList = "";
        inputDataModel.siteList = parentInputParams.siteId;
        inputDataModel.filter = "Site^" + inputDataModel.radioComplete + "^" + inputDataModel.radioOptional;

        return taskTodoModel.getSiteDetail(inputDataModel)
            .then((result) => {
                inputDataModel.data = result.data;
                inputDataModel.totalCount = result.total;
                inputDataModel.pageIndex = result.pageIndex;
                inputDataModel.pageSize = result.pageSize;
            })
            .catch((error) => {
                this.handleError(error);
            })
            .finally(() => { this.hideLoading() });
    }

    let _getData = () => {
        _getSiteDetailList();
    }

    let _initControls = () => {
        _getData();
    }

    let _downloadExcel = () => {
        this.showLoading();

        inputDataModel.fromDate = filterparentParams.fromDate;
        inputDataModel.toDate = filterparentParams.toDate;
        inputDataModel.taskList = filterparentParams.selectedTaskListArr.join('^');
        inputDataModel.siteList = filterparentParams.selectedSites.map(s => s.code).join('^');
        inputDataModel.filter = "Site^" + inputDataModel.radioComplete + "^" + inputDataModel.radioOptional;
        let fileName = uuidv4();

        return taskTodoModel.downloadExcelSite(inputDataModel, fileName)
            .catch((error) => {
                this.handleError(error);
            })
            .finally(() => { this.hideLoading() });
    }

    let onPageSizeChanged = (pageIndex, pageSize) => {
        inputDataModel.pageIndex = pageIndex;
        inputDataModel.pageSize = pageSize;
        _getData();
    }

    let onPageChanged = (pageIndex) => {
        inputDataModel.pageIndex = pageIndex;
        _getData();
    }

    let _dialogClosed = () => {
        isMsgOpen = false;
    }

    let _cancel = () => {
        onClose();
    }

    return {
        oninit: (vnode) => {
            if (vnode.attrs.onClose) {
                onClose = vnode.attrs.onClose;
            }
            if (vnode.attrs.parentEntity) {
                parentInputParams = vnode.attrs.parentEntity;

            }
            if (vnode.attrs.filterparentParams) {
                filterparentParams = vnode.attrs.filterparentParams;
            }
            if (vnode.attrs.type) {
                type = vnode.attrs.type;
                inputDataModel.radioOptional = type;
            }

            _initControls();
        },
        view: (vnode) => {
            return [
                m('.row',
                    m('.col-md-12',
                        m('.card.mb-3.mt-2',
                            m('.card-body.py-3',
                                m('.row',
                                    m('.container',
                                        m('.row', m('h5', parentInputParams.siteName)),
                                        m('.row',
                                            m('.col-md-2',
                                                m('.form-check.form-check-inline',
                                                    m('input.form-check-input[type="radio"][name="radioOptional"]', {
                                                        checked: inputDataModel.radioOptional == "",
                                                        onclick: (e) => {
                                                            inputDataModel.radioOptional = "";
                                                            inputDataModel.pageIndex = 1;
                                                            _getData();
                                                        }
                                                    }),
                                                    m('label.form-check-label', this.getText("LT00000143", "All"))
                                                )
                                            ),
                                            m('.col-md-2',
                                                m('.form-check.form-check-inline',
                                                    m('input.form-check-input[type="radio"][name="radioOptional"]', {
                                                        checked: inputDataModel.radioOptional == "Y",
                                                        onclick: (e) => {
                                                            inputDataModel.radioOptional = "Y";
                                                            inputDataModel.pageIndex = 1;
                                                            _getData();
                                                        }
                                                    }),
                                                    m('label.form-check-label', this.getText("LT00000115", "Mandatory"))
                                                )
                                            ),
                                            m('.col-md-2',
                                                m('.form-check.form-check-inline',
                                                    m('input.form-check-input[type="radio"][name="radioOptional"]', {
                                                        checked: inputDataModel.radioOptional == "N",
                                                        onclick: (e) => {
                                                            inputDataModel.radioOptional = "N";
                                                            inputDataModel.pageIndex = 1;
                                                            _getData();
                                                        }
                                                    }),
                                                    m('label.form-check-label', this.getText("LT00000131", "Optional"))
                                                )
                                            ),
                                        ),
                                        m('.row',
                                            m('.col-md-2',
                                                m('.form-check.form-check-inline',
                                                    m('input.form-check-input[type="radio"][name="radioType"]', {
                                                        checked: inputDataModel.radioComplete == "",
                                                        onclick: (e) => {
                                                            inputDataModel.radioComplete = "";
                                                            inputDataModel.pageIndex = 1;
                                                            _getData();
                                                        }
                                                    }),
                                                    m('label.form-check-label', this.getText("LT00000143", "All"))
                                                )
                                            ),
                                            m('.col-md-2',
                                                m('.form-check.form-check-inline',
                                                    m('input.form-check-input[type="radio"][name="radioType"]', {
                                                        checked: inputDataModel.radioComplete == "001",
                                                        onclick: (e) => {
                                                            inputDataModel.radioComplete = "001";
                                                            inputDataModel.pageIndex = 1;
                                                            _getData();
                                                        }
                                                    }),
                                                    m('label.form-check-label', this.getText("LT00000130", "Not Complete"))
                                                )
                                            ),
                                            m('.col-md-2',
                                                m('.form-check.form-check-inline',
                                                    m('input.form-check-input[type="radio"][name="radioType"]', {
                                                        checked: inputDataModel.radioComplete == "002",
                                                        onclick: (e) => {
                                                            inputDataModel.radioComplete = "002";
                                                            inputDataModel.pageIndex = 1;
                                                            _getData();
                                                        }
                                                    }),
                                                    m('label.form-check-label', this.getText("LT00000129", "Complete"))
                                                )
                                            ),
                                        )
                                    )
                                ),

                            )
                        ),

                        m('.card',
                            m('.card-body.pt-0',
                                m('.row',
                                    m(".col-md-12.p-0",
                                        m('.row',
                                            m('.d-flex.justify-content-end.mt-2.mb-2',
                                                m('.p-2',
                                                    m('a.primary-link.title-link', { onclick: _downloadExcel },
                                                        m('span.card-label.mb-1.fs-7',
                                                            m('i.bi.bi-file-earmark-arrow-down.me-0'),
                                                        )
                                                    )
                                                )
                                            )),
                                        m("",
                                            m(".col-12",
                                                m(".table-responsive",
                                                    m("table.table", [
                                                        m("thead.thead-bggrey",
                                                            m("tr.align-middle", [
                                                                m("th"),
                                                                m("th", { "scope": "col" }, this.getText("LT00000050", "User Name")),
                                                                m("th", { "scope": "col" }, this.getText("LT00000078", "Task Name")),
                                                                m("th", { "scope": "col" }, this.getText("LT00000115", "Mandatory")),
                                                                m("th", { "scope": "col" }, this.getText("LT00000145", "Completion Time")),
                                                                m("th", { "scope": "col" }, this.getText("LT00000015", "Status"))
                                                            ])
                                                        ),
                                                        m("tbody",
                                                            inputDataModel.data.length == 0 &&
                                                            m("tr", { "class": "align-middle" },
                                                                m("td", { "colspan": "7" }, this.getText("EM00000141", "No records found."))
                                                            ),
                                                            inputDataModel.data.map(gc => [
                                                                m("tr",
                                                                    [
                                                                        m("td", gc.userPhoto == "" && m('img.userImg-circle[src="' + staticUrls.emptyUserImage + '"]'),
                                                                            gc.userPhoto != "" && m('img.userImg-circle[src="' + gc.userPhoto + '"]')
                                                                        ),
                                                                        m("td", gc.userName),
                                                                        m("td", gc.taskName),
                                                                        m("td", gc.mandatoryFlag),
                                                                        m("td", gc.toDoTime),
                                                                        m("td.center", gc.toDoStatus == 'Not Complete' && m('.badge.rounded-pill.grey-bg-status', gc.toDoStatus),
                                                                            gc.toDoStatus == 'Completed' && m('.badge.rounded-pill.green-bg-status', gc.toDoStatus)
                                                                        )
                                                                    ])
                                                            ]),
                                                        )
                                                    ])
                                                ),
                                                !this.isLoading && m(".px-3",
                                                    m(paginationComponent, { currentPage: inputDataModel.pageIndex, pageSize: inputDataModel.pageSize, totalItems: inputDataModel.totalCount, onPageChanged: onPageChanged, onPageSizeChanged: onPageSizeChanged })
                                                )
                                            )
                                        )
                                    )
                                )
                            ),
                            m('.card-footer',
                                m('.col-md-12 .gap-2 .d-flex .justify-content-center',
                                    m(
                                        "button.btn.btn-white[type='button']", { onclick: _cancel },
                                        this.getText("LT00000021", "Close")
                                    )
                                )
                            )
                        )
                    ),
                    m(messageComponent, { isOpen: isMsgOpen, message: showMsg, title: msgTitle, onClosed: _dialogClosed })
                ),
                this.getBaseViews()
            ]
        }
    }
}
